import React, { ComponentPropsWithRef, forwardRef } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { ReactDefaultPropsWithChildren } from "../../types/react";

import styles from "./TileImageTeaser.scss";

type TileImageTeaserTileContentBasePropsProps = {
  customClass?: string;
};

export type TileImageTeaserTileContentProps = TileImageTeaserTileContentBasePropsProps &
  Omit<
    React.ComponentPropsWithoutRef<"div">,
    keyof TileImageTeaserTileContentBasePropsProps
  >;

const defaultProps = {
  children: undefined,
  customClass: undefined,
} as const;

const validatedDefaultProps: ReactDefaultPropsWithChildren<
  TileImageTeaserTileContentBasePropsProps,
  typeof defaultProps
> = defaultProps;

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
} as const;

export const TileImageTeaserTileContentWithRef = (
  props: TileImageTeaserTileContentProps,
  ref: ComponentPropsWithRef<"div">["ref"]
): JSX.Element => {
  const { children, customClass, ...restProps } = props;
  return (
    <div ref={ref} className={cx(styles.content, customClass)} {...restProps}>
      {children}
    </div>
  );
};

export const TileImageTeaserTileContent = forwardRef(
  TileImageTeaserTileContentWithRef
);

TileImageTeaserTileContent.propTypes = propTypes;
TileImageTeaserTileContent.defaultProps = validatedDefaultProps;

TileImageTeaserTileContent.displayName = "TileImageTeaser.Tile.Content";

export default TileImageTeaserTileContent;
